module.exports = __webpack_public_path__ + "14878d1801652f95fca78491595a8ad9.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/vivi.jpg
// module id = 592
// module chunks = 30